import logoIcon from "../../assets/Logos/logo.svg";

const Logo = () => {
  return <img className="Logo" src={logoIcon} alt=""></img>;
};

export default Logo;
